
import { propsInstance } from "@/lib/util";
import { Component, MixedVue, mixins } from "@/vue";
import { Watch } from "vue-property-decorator";

const Props = propsInstance<{
  src: string;
}>({
  src: { type: String, required: true },
});

@Component({
  name: "SvgIcon",
})
export default class SvgIcon extends mixins(MixedVue, Props) {
  $emit: {
    (e: "load");
  };

  mounted() {
    this.getImage();
  }

  @Watch("src")
  async getImage() {
    if (!this.src) {
      this.$el.textContent = "";
      return;
    }
    const image = await (await fetch(this.src)).text();
    const svg = new DOMParser().parseFromString(image, "image/svg+xml").firstChild as HTMLElement;
    this.$el.textContent = "";
    [...svg.attributes].forEach(({ name, value }) => this.$el.setAttribute(name, value));
    this.$el.append(...svg.childNodes);
    this.$emit("load");
  }
}
